export default {
  bigger: '2.2rem',
  big: '1.6rem',
  regular: '1.4rem',
  small: '1.2rem',
  smaller: '1.0rem',
};
